import * as i0 from '@angular/core';
import { InjectionToken, inject, NgModule } from '@angular/core';
import { createServiceApi, serviceTypes, combineEffectsWithProviders } from '@essent/common';
export { Channel, DirectionTariff, EnergyType, IncomingPaymentMethod, ProductDuration } from '@essent/common';
import * as i1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';

const EXTENSION_OFFER_PATH = 'contracting/changecontract';

const API = new InjectionToken('api-extend-contract');

var CampaignType;
(function (CampaignType) {
    CampaignType["ABOVE_THE_LINE"] = "above_the_line";
    CampaignType["BELOW_THE_LINE"] = "below_the_line";
})(CampaignType || (CampaignType = {}));

const apiVersion$f = '1';
const getAddressApi = createServiceApi('[ExtensionOfferState] Get address', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/supplyaddress/v${apiVersion$f}`,
    version: apiVersion$f,
    getParams: payload => payload,
    extractFromNestedKey: 'payload'
});
// TODO: this requires mapping the response from payload to the response

const apiVersion$e = '1';
const getBudgetBillApi = createServiceApi('[ExtensionOfferState] Get budget bill', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/budgetbillamount/v${apiVersion$e}`,
    version: apiVersion$e,
    getParams: payload => payload,
    extractFromNestedKey: 'payload'
});

const apiVersion$d = '1';
const putBudgetBillApi = createServiceApi('[ExtensionOfferState] Put budget bill', 'put', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/budgetbillamount/v${apiVersion$d}`,
    version: apiVersion$d,
    getBody: payload => payload
});

const apiVersion$c = '1';
const getCampaignsApi = createServiceApi('[ExtensionOfferState] Get campaigns', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/campaigns/v${apiVersion$c}`,
    version: apiVersion$c,
    getParams: payload => payload,
    extractFromNestedKey: 'payload'
});

const apiVersion$b = '1';
const putConfirmationApi = createServiceApi('[ExtensionOfferState] Put confirmation', 'put', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/confirmation/v${apiVersion$b}`,
    version: apiVersion$b,
    getHeaders: payload => {
        const headers = { Accept: 'application/json' };
        if (payload.payload?.externalPartnerId) {
            headers['external-partner-id'] = payload.payload.externalPartnerId;
        }
        return headers;
    },
    getBody: payload => {
        const { externalPartnerId, ...rest } = payload.payload || {};
        return { ...payload, payload: rest };
    }
});

const apiVersion$a = '1';
const getConsumptionApi = createServiceApi('[ExtensionOfferState] Get consumption', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/consumption/v${apiVersion$a}`,
    version: apiVersion$a,
    getParams: payload => payload,
    extractFromNestedKey: 'payload'
});

const apiVersion$9 = '1';
const putConsumptionApi = createServiceApi('[ExtensionOfferState] Put consumption', 'put', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/consumption/v${apiVersion$9}`,
    version: apiVersion$9,
    getBody: payload => payload
});

const apiVersion$8 = '1';
const putCurrentContractApi = createServiceApi('[ExtensionOfferState] Put current contract', 'put', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/currentcontract/v${apiVersion$8}`,
    version: apiVersion$8,
    getParams: ({ accountId }) => ({ accountId }),
    getBody: ({ accountId, ...data }) => data
});

const apiVersion$7 = '1';
const putEmailApi = createServiceApi('[ExtensionOfferState] Put email', 'put', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/email/v${apiVersion$7}`,
    version: apiVersion$7,
    getBody: payload => payload
});

const apiVersion$6 = '1';
const getOfferApi = createServiceApi('[OfferState] Get Offer', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/offers/v${apiVersion$6}`,
    version: apiVersion$6,
    getParams: payload => payload,
    extractFromNestedKey: 'payload.0'
});

const apiVersion$5 = '1';
const putPropositionApi = createServiceApi('[ExtensionOfferState] Put proposition', 'put', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/proposition/v${apiVersion$5}`,
    version: apiVersion$5,
    getBody: payload => payload
});

const apiVersion$4 = '1';
const getRunningProcessesApi = createServiceApi('[ExtensionOfferState] Get running processes', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/activecases/v${apiVersion$4}`,
    version: apiVersion$4,
    getParams: payload => payload,
    extractFromNestedKey: 'payload'
});

const apiVersion$3 = '1';
const getStartDateApi = createServiceApi('[ExtensionOfferState] Get start date', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/startdate/v${apiVersion$3}`,
    version: apiVersion$3,
    getParams: payload => payload,
    extractFromNestedKey: 'payload'
});

const apiVersion$2 = '1';
const putStartDateApi = createServiceApi('[ExtensionOfferState] Put start date', 'put', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/startdate/v${apiVersion$2}`,
    version: apiVersion$2,
    getBody: payload => payload
});

const apiVersion$1 = '1';
const getSummaryApi = createServiceApi('[ExtensionOfferState] Get summary', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/summary/v${apiVersion$1}`,
    version: apiVersion$1,
    getParams: payload => payload,
    extractFromNestedKey: 'payload'
});

const apiVersion = '1';
const getTariffsApi = createServiceApi('[ExtensionOfferState] Get tariffs', 'get', serviceTypes(), {
    getUrl: `/${EXTENSION_OFFER_PATH}/tariffs/v${apiVersion}`,
    version: apiVersion,
    getParams: payload => payload,
    extractFromNestedKey: 'payload'
});

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(putCurrentContractApi, getCampaignsApi, getOfferApi, putPropositionApi, getConsumptionApi, putConsumptionApi, getRunningProcessesApi, getAddressApi, putBudgetBillApi, getBudgetBillApi, getSummaryApi, putConfirmationApi, putEmailApi, getStartDateApi, putStartDateApi, getTariffsApi);
class ExtensionOfferCoreModule {
    constructor() {
        const parentModule = inject(ExtensionOfferCoreModule, { optional: true, skipSelf: true });
        if (parentModule) {
            throw new Error('ExtensionOfferCoreModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: ExtensionOfferCoreModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "20.2.4", ngImport: i0, type: ExtensionOfferCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "20.2.4", ngImport: i0, type: ExtensionOfferCoreModule, imports: [i1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "20.2.4", ngImport: i0, type: ExtensionOfferCoreModule, providers: PROVIDERS, imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "20.2.4", ngImport: i0, type: ExtensionOfferCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: PROVIDERS
                }]
        }], ctorParameters: () => [] });

const { getAddressActions, getAddress, getAddressSuccess, getAddressError, getAddressClear } = getAddressApi;

const { putBudgetBillActions, putBudgetBill, putBudgetBillSuccess, putBudgetBillError, putBudgetBillClear } = putBudgetBillApi;
const { getBudgetBillActions, getBudgetBill, getBudgetBillSuccess, getBudgetBillError, getBudgetBillClear } = getBudgetBillApi;

const { getCampaignsActions, getCampaigns, getCampaignsSuccess, getCampaignsError, getCampaignsClear } = getCampaignsApi;

const { putConfirmationActions, putConfirmation, putConfirmationSuccess, putConfirmationError, putConfirmationClear } = putConfirmationApi;

const { getConsumptionActions, getConsumption, getConsumptionSuccess, getConsumptionError, getConsumptionClear } = getConsumptionApi;
const { putConsumptionActions, putConsumption, putConsumptionSuccess, putConsumptionError, putConsumptionClear } = putConsumptionApi;

const { putCurrentContractActions, putCurrentContract, putCurrentContractSuccess, putCurrentContractError, putCurrentContractClear } = putCurrentContractApi;

const { putEmailActions, putEmail, putEmailSuccess, putEmailError, putEmailClear } = putEmailApi;

const { getOffer, getOfferSuccess, getOfferError, getOfferClear, getOfferActions } = getOfferApi;

const { putPropositionActions, putProposition, putPropositionSuccess, putPropositionError, putPropositionClear } = putPropositionApi;

const { getRunningProcessesActions, getRunningProcesses, getRunningProcessesSuccess, getRunningProcessesError, getRunningProcessesClear } = getRunningProcessesApi;

var ProcessStatus;
(function (ProcessStatus) {
    ProcessStatus["IN_PROGRESS"] = "INPROGRESS";
    ProcessStatus["COMPLETED"] = "COMPLETED";
})(ProcessStatus || (ProcessStatus = {}));
var Source;
(function (Source) {
    Source["IPROCESS"] = "iProcess";
    Source["AMXBPM"] = "AMXBPM";
})(Source || (Source = {}));

const { putStartDateActions, putStartDate, putStartDateSuccess, putStartDateError, putStartDateClear } = putStartDateApi;
const { getStartDateActions, getStartDate, getStartDateSuccess, getStartDateError, getStartDateClear } = getStartDateApi;

const { getSummaryActions, getSummary, getSummarySuccess, getSummaryError, getSummaryClear } = getSummaryApi;

const { getTariffsActions, getTariffs, getTariffsSuccess, getTariffsError, getTariffsClear } = getTariffsApi;

/**
 * Generated bundle index. Do not edit.
 */

export { API, CampaignType, EXTENSION_OFFER_PATH, ExtensionOfferCoreModule, ProcessStatus, Source, getAddress, getAddressActions, getAddressClear, getAddressError, getAddressSuccess, getBudgetBill, getBudgetBillActions, getBudgetBillClear, getBudgetBillError, getBudgetBillSuccess, getCampaigns, getCampaignsActions, getCampaignsClear, getCampaignsError, getCampaignsSuccess, getConsumption, getConsumptionActions, getConsumptionClear, getConsumptionError, getConsumptionSuccess, getOffer, getOfferActions, getOfferClear, getOfferError, getOfferSuccess, getRunningProcesses, getRunningProcessesActions, getRunningProcessesClear, getRunningProcessesError, getRunningProcessesSuccess, getStartDate, getStartDateActions, getStartDateClear, getStartDateError, getStartDateSuccess, getSummary, getSummaryActions, getSummaryClear, getSummaryError, getSummarySuccess, getTariffs, getTariffsActions, getTariffsClear, getTariffsError, getTariffsSuccess, putBudgetBill, putBudgetBillActions, putBudgetBillClear, putBudgetBillError, putBudgetBillSuccess, putConfirmation, putConfirmationActions, putConfirmationClear, putConfirmationError, putConfirmationSuccess, putConsumption, putConsumptionActions, putConsumptionClear, putConsumptionError, putConsumptionSuccess, putCurrentContract, putCurrentContractActions, putCurrentContractClear, putCurrentContractError, putCurrentContractSuccess, putEmail, putEmailActions, putEmailClear, putEmailError, putEmailSuccess, putProposition, putPropositionActions, putPropositionClear, putPropositionError, putPropositionSuccess, putStartDate, putStartDateActions, putStartDateClear, putStartDateError, putStartDateSuccess };
